const businessInvitationScores = [
    { haveInvitation: true, score: 30 },
    { haveInvitation: false, score: 0 },
];

export default businessInvitationScores;
